/** @format */

import { Row } from 'components/ui/Grid';
import styled from 'styled-components';

const Wrapper = styled(Row)`
  justify-content: space-between;
  position: relative;
  padding: 0 20px 3em 20px
`;

Wrapper.displayName = '   Wrapper';
export default Wrapper;
